export default __webpack_public_path__ + "static/media/test_image_1.f4f6a12f.png";